import ModuleWrapper from 'shared-lib/containers/Module';

const ActivityLog = () => import(/* webpackChunkName: "dashboard" */ '@/views/activityLog/ActivityLog');

const meta = (data = {}) => ({
    permissionsModuleName: 'audit_log',
    auth: true,
    ...data,
});

export default {
    path: '/activity-log',
    component: ModuleWrapper,
    meta: meta({
        permission: 'list',
    }),
    children: [
        {
            path: '',
            name: 'Activity Log',
            component: ActivityLog,
            meta: meta({
                permission: 'list',
            }),
        },
    ],
};
